import Color from 'color';
import {type Band} from 'uplot';

import {type LineNameMap, type SeriesEntry} from './getSeriesEntries';

export function getBands(
  seriesEntries: (SeriesEntry | null)[],
  lineNameMap: LineNameMap
): Band[] {
  // uPlot calls filled area ranges "bands"; the adapter entries use the same
  // terminology at this rendering boundary.
  const bands: Band[] = [];

  seriesEntries.forEach((entry, idx) => {
    if (entry == null) {
      return;
    }
    const seriesIdx = idx;

    if (entry.type === 'band-max') {
      const color = entry.line.color ?? 'red';
      const lineName = entry.line.name;
      const metricName = entry.line.metricName;
      if (lineName == null || metricName == null) {
        return;
      }
      const lineNameMapEntry = lineNameMap.get(lineName)?.get(metricName);
      if (lineNameMapEntry == null) {
        return;
      }
      const bandMinSeriesIndex = lineNameMapEntry.bandMinSeriesIndex;
      if (bandMinSeriesIndex == null) {
        return;
      }

      bands.push({
        series: [seriesIdx, bandMinSeriesIndex],
        fill: Color(color).rgb().string(),
      });
    }
  });

  return bands;
}
